import React from 'react'
import '../App.css'

export default function Title(props) {
    return (
        <div >
            <h1>{props.title}</h1>
        </div>
    )
}